import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { EtmfListView } from '../../constants/etmf'
import { EtmfListPage } from './list'

const Etmf = () => {
  const { etmfTab = 'products' } = useParams<{ etmfTab: string }>()
  const { t } = useTranslation()

  // Pages that are not yet implemented - show placeholder text
  if (etmfTab === 'status') {
    return <div className="page-frame">{t('ETMF_STATUS_TITLE', 'eTMF Study Overview')}</div>
  }

  // Map tab names to EtmfListView values for implemented pages
  const viewMap: Record<string, string> = {
    products: EtmfListView.PRODUCT,
    studies: EtmfListView.TRIAL,
    environments: EtmfListView.ENVIRONMENT,
    countries: EtmfListView.COUNTRY,
    sites: EtmfListView.SITE,
    'file-plans': EtmfListView.FILE_PLAN,
    packages: EtmfListView.PACKAGE
  }

  const currentView = viewMap[etmfTab] || EtmfListView.PRODUCT

  return <EtmfListPage listView={currentView as any} />
}

export default Etmf
